// extracted by mini-css-extract-plugin
export var base = "_42-0";
export var updateBanner = "_42-1";